// extracted by mini-css-extract-plugin
export default {"button":"Button_button__g9p4b","accent":"Button_accent__HjM9K","secondary":"Button_secondary__Qud9j","disabled":"Button_disabled__nDlEC"};